/* Regles du « 21 du Jarl », sans DOM : sabot, valeur des mains, jeu du
   croupier, issue d'une manche. Pendant pur de vd-jeu-21.js, charge juste
   avant lui, et teste a part par tests/jeu-21.test.mjs.

   Blackjack a un jeu : 13 rangs, chaque couleur est une rune de la gamme
   (six au lieu de quatre, la proportion des rangs est la meme). Le croupier
   tire jusqu'a 17 et reste sur un 17 souple. Le tirage vient de
   crypto.getRandomValues : aucune manche n'est jouee d'avance. */
(function (racine) {
  'use strict';

  var RANGS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'V', 'D', 'R'];

  function valeurRang(rang) {
    if (rang === 'A') return 11;
    if (rang === 'V' || rang === 'D' || rang === 'R') return 10;
    return Number(rang);
  }

  function hasardCrypto(n) {
    var tampon = new Uint32Array(1);
    var plafond = Math.floor(0x100000000 / n) * n;
    var tirage;
    do {
      racine.crypto.getRandomValues(tampon);
      tirage = tampon[0];
    } while (tirage >= plafond);
    return tirage % n;
  }

  function creerSabot(couleurs, hasard) {
    var tirer = hasard || hasardCrypto;
    var cartes = [];
    for (var c = 0; c < couleurs.length; c++) {
      for (var r = 0; r < RANGS.length; r++) {
        cartes.push({ rang: RANGS[r], couleur: couleurs[c] });
      }
    }
    for (var i = cartes.length - 1; i > 0; i--) {
      var j = tirer(i + 1);
      var tmp = cartes[i];
      cartes[i] = cartes[j];
      cartes[j] = tmp;
    }
    return cartes;
  }

  function valeurMain(main) {
    var total = 0;
    var asOnze = 0;
    for (var i = 0; i < main.length; i++) {
      total += valeurRang(main[i].rang);
      if (main[i].rang === 'A') asOnze++;
    }
    while (total > 21 && asOnze > 0) {
      total -= 10;
      asOnze--;
    }
    return { total: total, souple: asOnze > 0 };
  }

  function estBlackjack(main) {
    return main.length === 2 && valeurMain(main).total === 21;
  }

  function croupierTire(main) {
    return valeurMain(main).total < 17;
  }

  function jouerCroupier(main, sabot) {
    while (croupierTire(main)) {
      if (!sabot.length) throw new Error('sabot vide pendant le tour du croupier');
      main.push(sabot.pop());
    }
    return main;
  }

  function issue(joueur, croupier) {
    var j = valeurMain(joueur).total;
    var c = valeurMain(croupier).total;
    var bjJoueur = estBlackjack(joueur);
    var bjCroupier = estBlackjack(croupier);
    if (j > 21) return 'perdu';
    if (bjJoueur && !bjCroupier) return 'gagne';
    if (bjCroupier && !bjJoueur) return 'perdu';
    if (c > 21) return 'gagne';
    if (j > c) return 'gagne';
    if (j < c) return 'perdu';
    return 'egalite';
  }

  racine.VDJeu21Regles = {
    RANGS: RANGS,
    valeurRang: valeurRang,
    creerSabot: creerSabot,
    valeurMain: valeurMain,
    estBlackjack: estBlackjack,
    croupierTire: croupierTire,
    jouerCroupier: jouerCroupier,
    issue: issue
  };
})(typeof window !== 'undefined' ? window : globalThis);
